import { useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useFeature } from 'flagged'
import { Row, Col } from 'react-bootstrap'
import Link from 'components/link'
import { helloBabyBoxFaq, helloBabyBoxOOS } from 'lib/urls'
import { numberToCurrency } from 'lib/money'
import { CONFIG } from 'shared/constants'
import { InfoButton } from 'components/buttons'
import { DangerAlert } from 'components/alerts'
import Image from 'components/image'
import { getShippingConsolidation } from 'registry/reducers'

const HBBCart = ({ checkoutPath }) => {
  const [submitting, setSubmitting] = useState()
  let showFreeShipping = false
  const isHbbFreeShippingWithSimpleShippingEnabled = useFeature(
    'hbb_free_shipping_with_simple_shipping_enabled'
  )
  if (isHbbFreeShippingWithSimpleShippingEnabled) {
    const { consolidationChoice } = useSelector((state) =>
      getShippingConsolidation(state)
    )
    const isEnrolledInSimpleShipping = consolidationChoice === 'rolling'
    showFreeShipping = isEnrolledInSimpleShipping
  }
  const price = showFreeShipping
    ? 0.0
    : CONFIG.registry.helloBabyBoxShippingPrice

  return (
    <>
      <Row>
        <Col sm={6}>
          <Image
            alt="Hello Baby Box"
            className="mtl img-responsive"
            src="//images.babylist.com/image/upload/f_auto,q_auto/v1568844195/bg-hbb_2x_oou5bf.png"
          />
        </Col>

        <Col sm={6}>
          <div className="pam gray-bg">
            <table className="table mbm">
              <tbody>
                <tr>
                  <td style={{ borderBottom: 0 }}>Hello Baby Box</td>
                  <td style={{ borderBottom: 0 }} className="text-right">
                    $0.00
                  </td>
                </tr>
                <tr>
                  <td>Shipping</td>
                  <td className="text-right">{numberToCurrency(price)}</td>
                </tr>
              </tbody>
              <tfoot className="text-bold bts">
                <tr>
                  <td>Total</td>
                  <td className="text-right">{numberToCurrency(price)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <InfoButton
            block
            className="block mha mvm"
            href={checkoutPath}
            onClick={() => setSubmitting(true)}
            submitting={submitting}
          >
            Get my Hello Baby Box
          </InfoButton>
        </Col>
      </Row>

      <p className="h6 text-justify mtl mbn">
        {`Additional handling and location surcharges may apply. The shipping fee is non-refundable. For more information, `}
        <Link newWindow url={helloBabyBoxFaq}>
          visit our FAQs
        </Link>
        .
      </p>
    </>
  )
}

HBBCart.propTypes = {
  checkoutPath: PropTypes.string,
}

HBBCart.defaultProps = {
  checkoutPath: '',
}

const HBBUnavailable = () => (
  <Row>
    <Col sm={6}>
      <Image
        alt="Hello Baby Box"
        className="mtl img-responsive"
        src="//images.babylist.com/image/upload/f_auto,q_auto/v1568844195/bg-hbb_2x_oou5bf.png"
      />
    </Col>

    <Col sm={6}>
      <DangerAlert className="pal mtm">
        <div className="mls">
          <p className="h6 mvn">
            We're sorry, Hello Baby Box is currently out of stock. We restock
            Hello Baby Box often. Please check back soon.
          </p>
          <Link className="small" newWindow url={helloBabyBoxOOS}>
            Learn more
          </Link>
        </div>
      </DangerAlert>
    </Col>
  </Row>
)

const QualifiedBody = ({ checkoutPath, isHBBAvailable }) => (
  <div className="mas">
    <p className="mbl text-center lead">
      Congrats! You've qualified for a Hello Baby Box!
    </p>
    {isHBBAvailable ? (
      <HBBCart checkoutPath={checkoutPath} />
    ) : (
      <HBBUnavailable />
    )}
  </div>
)

QualifiedBody.propTypes = {
  checkoutPath: PropTypes.string,
  isHBBAvailable: PropTypes.bool,
}

QualifiedBody.defaultProps = {
  checkoutPath: '',
  isHBBAvailable: false,
}

export default QualifiedBody
